var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-img',{staticClass:"my-1",attrs:{"max-width":"width","max-height":"80","contain":"","src":_vm.source},on:{"error":function($event){_vm.source = _vm.imagePath}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }